export const getHashtagUrl = (sectionUrl, hashtag) =>
  `${sectionUrl}/hashtags/${hashtag}`;
